import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import { Autocomplete, Switch } from "@mui/material";

// Muwafiq components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import crudsService from "services/cruds-service";

import FormField from "components/FormField";
import i18n from "i18n";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import dayjs from "dayjs";

const FilterProject = ({ setFilterUrl }) => {
  const [categories, setCategories] = useState([]);
  const [tags, setTags] = useState([]);
  const [allStatus, setAllStatus] = useState([]);
  const [countries, setCountries] = useState([]);

  const { t } = i18n;

  const [info, setInfo] = useState({
    name: "",
    cost_from: "",
    cost_to: "",
    date_begin: "",
    date_end: "",
    benficial_num: "",
    period: "",
    category_id: null,
    tag_id: null,
    impl_country_id: null,
    status_id: null,
    all_amount_required: false,
    zakaat_available: false,
    target_segments: [],
  });

  const prepareNewArr = (arr, objKey) => {
    let newArr = [];
    for (const key in arr) {
      if (Object.hasOwnProperty.call(arr, key)) {
        const element = arr[key];
        newArr.push({
          id: element.id,
          name: element?.translations[0][objKey || "name"],
        });
      }
    }
    return newArr;
  };

  useEffect(() => {
    (async () => {
      try {
        // const categoryData = await crudsService.getCategories();
        const categoryData = await crudsService.getAllData(
          `items/categories?fields=id,translations.name,parent_id.id,parent_id.translations.name,projects.id,children.id`,
        );
        setCategories(prepareNewArr(categoryData.data));
        const tagsData = await crudsService.getAllData(
          "items/tags?fields=id,translations.name&filter[type][_eq]=p",
        );
        setTags(prepareNewArr(tagsData.data));
        // const statusData = await crudsService.getItems("project_status");
        const statusData = await crudsService.getAllData(
          `items/project_status?fields=*,translations.name,projects.id`,
        );
        setAllStatus(prepareNewArr(statusData.data));
        const countriesData = await crudsService.getAllData(
          `items/countries?fields=*,translations.name,projects.id`,
        );
        setCountries(prepareNewArr(countriesData.data));
      } catch (err) {
        console.error(err);
        return null;
      }
    })();
  }, []);

  const changeHandler = (e) => {
    console.log(e.target.value, e.target.name, e.target.value);

    setInfo({
      ...info,
      [e.target.name]: e.target.value,
    });
  };

  const autoSwitchChangeHandler = (name, v) => {
    setInfo({
      ...info,
      [name]: v,
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      console.log(info);

      let str = "";
      const values = {
        benficial_num: info.benficial_num,
        period: info.period,
        impl_country_id: info.impl_country_id?.id,
        status_id: info.status_id?.id,
        zakaat_available: info.zakaat_available,
        all_amount_required: info.all_amount_required,
      };

      if (info.cost_from && info.cost_to)
        values["cost"] = {
          filter: "_between",
          val: `[${info.cost_from},${info.cost_to}]`,
        };

      if (info.date_begin && info.date_end) {
        values["date_begin"] = {
          filter: "_gte",
          val: info.date_begin,
        };
        values["date_end"] = {
          filter: "_lt",
          val: info.date_end,
        };
      }

      if (info.category_id) {
        values["category_id"] = {
          key: "[categories][categories_id]",
          filter: "_eq",
          val: info.category_id?.id,
        };
      }

      if (info.tag_id) {
        values["tag_id"] = {
          key: "[tags][tags_id]",
          filter: "_eq",
          val: info.tag_id?.id,
        };
      }

      if (info.name) {
        values["name"] = {
          key: "[translations][name]",
          filter: "_contains",
          val: info.name,
        };
      }

      const keys = Object.keys(values);
      keys.forEach((element) => {
        if (
          values[element] &&
          (!Array.isArray(values[element]) || values[element].length > 0)
        ) {
          if (element === "date_end") {
            str += `&filter[date_begin][${
              values[element]["filter"] || "_eq"
            }]=${values[element]["val"] || values[element]}`;
          } else {
            str += `&filter${values[element]["key"] || `[${element}]`}[${
              values[element]["filter"] || "_eq"
            }]=${values[element]["val"] || values[element]}`;
          }
        }
      });

      setFilterUrl(str);
    } catch (err) {
      console.log({ error: true, textError: err.message });
      return null;
    }
  };

  const formatForInput = (date) => {
    if (!date) return "";
    return dayjs(date).format("YYYY-MM-DDTHH:mm");
  };

  const parseFromInput = (value) => {
    return value ? dayjs(value) : null;
  };

  return (
    <MDBox
      component="form"
      method="POST"
      onSubmit={submitHandler}
      encType="multipart/form-data"
    >
      <MDBox display="flex" flexDirection="column" px={2} my={4}>
        <MDBox display="flex" flexDirection="column">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormField
                onChange={changeHandler}
                label={"الاسم"}
                name="name"
                value={info.name}
                placeholder="الاسم"
              />
            </Grid>
            <Grid item xs={6}>
              <FormField
                onChange={changeHandler}
                label={"التكلفة من"}
                name="cost_from"
                value={info.cost_from}
                placeholder="التكلفة من"
              />
            </Grid>
            <Grid item xs={6}>
              <FormField
                onChange={changeHandler}
                label={"إلى"}
                name="cost_to"
                value={info.cost_to}
                placeholder="إلى"
              />
            </Grid>
            {/* <Grid item xs={6}>
              <FormField
                label="بداية النشر من"
                type="datetime-local"
                name="date_begin"
                value={formatForInput(info?.date_begin)}
                onChange={(e) =>
                  changeHandler({
                    target: {
                      name: "date_begin",
                      // value: parseFromInput(e.target.value),
                      value: e.target.value
                        ? dayjs(e.target.value).toISOString()
                        : null,
                    },
                  })
                }
                variant="outlined"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  backgroundColor: "#ffffff",
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#ffffff",
                  },
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormField
                label="إلى"
                type="datetime-local"
                name="date_end"
                value={formatForInput(info?.date_end)}
                onChange={(e) =>
                  changeHandler({
                    target: {
                      name: "date_end",
                      // value: parseFromInput(e.target.value),
                      value: e.target.value
                        ? dayjs(e.target.value).toISOString()
                        : null,
                    },
                  })
                }
                variant="outlined"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  backgroundColor: "#ffffff",
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#ffffff",
                  },
                }}
              />
            </Grid> */}
            <Grid item xs={12}>
              <FormField
                onChange={changeHandler}
                label="عدد المستفيدين"
                name="benficial_num"
                value={info.benficial_num}
                placeholder="عدد المستفيدين"
              />
            </Grid>
            <Grid item xs={12}>
              <FormField
                onChange={changeHandler}
                label="المدة"
                name="period"
                value={info.period}
                placeholder={"المدة"}
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                variant="outlined"
                options={countries}
                name="impl_country_id"
                renderOption={(props, option) => (
                  <li {...props} key={option.id}>
                    {option.data ? option.data.name : option.name}
                  </li>
                )}
                getOptionLabel={(option) => {
                  if (option.data) {
                    if (option.data.name) return option.data.name;
                  } else {
                    if (option) {
                      if (option.name) return option.name;
                    }
                  }
                  return "";
                }}
                isOptionEqualToValue={(option, item) =>
                  option === item || option?.id === item?.id
                }
                renderInput={(params) => (
                  <MDInput
                    variant="outlined"
                    {...params}
                    //variant="standard"
                    label="بلد التنفيذ"
                  />
                )}
                // onChange={(e, v) => setCountery(v)}
                onChange={(e, v) =>
                  changeHandler({
                    target: { name: "impl_country_id", value: v },
                  })
                }
                value={info.impl_country_id}
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                options={categories}
                name="category_id"
                renderOption={(props, option) => (
                  <li {...props} key={option.id}>
                    {option.data ? option.data.name : option.name}
                  </li>
                )}
                getOptionLabel={(option) => {
                  if (option.data) {
                    if (option.data.name) return option.data.name;
                  } else {
                    if (option) {
                      if (option.name) return option.name;
                    }
                  }
                  return "";
                }}
                isOptionEqualToValue={(option, item) =>
                  option === item || option?.id === item?.id
                }
                variant="outlined"
                renderInput={(params) => (
                  <MDInput
                    {...params}
                    //variant="standard"
                    label="التصنيف"
                  />
                )}
                onChange={(e, v) =>
                  changeHandler({
                    target: { name: "category_id", value: v },
                  })
                }
                value={info.category_id}
              />
            </Grid>
            {/* <Grid item xs={12}>
              <Autocomplete
                options={tags}
                name="tag_id"
                renderOption={(props, option) => (
                  <li {...props} key={option.id}>
                    {option.data ? option.data.name : option.name}
                  </li>
                )}
                getOptionLabel={(option) => {
                  if (option.data) {
                    if (option.data.name) return option.data.name;
                  } else {
                    if (option) {
                      if (option.name) return option.name;
                    }
                  }
                  return "";
                }}
                isOptionEqualToValue={(option, item) =>
                  option === item || option?.id === item?.id
                }
                variant="outlined"
                renderInput={(params) => (
                  <MDInput
                    {...params}
                    //variant="standard"
                    label="الوسم"
                  />
                )}
                onChange={(e, v) =>
                  changeHandler({
                    target: { name: "tag_id", value: v },
                  })
                }
                value={info.tag_id}
              />
            </Grid> */}
            <Grid item xs={12}>
              <Autocomplete
                options={allStatus}
                name="status_id"
                renderOption={(props, option) => (
                  <li {...props} key={option.id}>
                    {option.data ? option.data.name : option.name}
                  </li>
                )}
                getOptionLabel={(option) => {
                  if (option.data) {
                    if (option.data.name) return option.data.name;
                  } else {
                    if (option) {
                      if (option.name) return option.name;
                    }
                  }
                  return "";
                }}
                isOptionEqualToValue={(option, item) =>
                  option === item || option?.id === item?.id
                }
                renderInput={(params) => (
                  <MDInput
                    variant="outlined"
                    {...params}
                    //variant="standard"
                    label="الحالة"
                  />
                )}
                onChange={(e, v) =>
                  changeHandler({
                    target: { name: "status_id", value: v },
                  })
                }
                value={info.status_id}
              />
            </Grid>
            <Grid item xs={12}>
              <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                <MDBox mt={0.5}>
                  <Switch
                    // onChange={changeHandler}
                    name="zakaat_available"
                    checked={!!info.zakaat_available}
                    onChange={() =>
                      autoSwitchChangeHandler(
                        "zakaat_available",
                        !info.zakaat_available,
                      )
                    }
                  />
                </MDBox>
                <MDBox width="80%" ml={0.5}>
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    تجوز الزكاة
                  </MDTypography>
                </MDBox>
              </MDBox>
            </Grid>
            <Grid item xs={12}>
              <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                <MDBox mt={0.5}>
                  <Switch
                    // onChange={changeHandler}
                    name="all_amount_required"
                    checked={!!info.all_amount_required}
                    onChange={() =>
                      autoSwitchChangeHandler(
                        "all_amount_required",
                        !info.all_amount_required,
                      )
                    }
                  />
                </MDBox>
                <MDBox width="80%" ml={0.5}>
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    عطاءات
                  </MDTypography>
                </MDBox>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox ml="auto" mt={4} mb={2} display="flex" justifyContent="flex-end">
          <MDButton variant="gradient" color="info" size="small" type="submit">
            {t("search")}
          </MDButton>
        </MDBox>
      </MDBox>
    </MDBox>
  );
};

export default FilterProject;
